import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconUserBlock$1 = /*@__PURE__*/ proxyCustomElement(class WppIconUserBlock extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-user-block", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M14.5475 10.0933C17.007 10.0933 19.0009 12.0871 19.0009 14.5466C19.0009 17.0062 17.007 19 14.5475 19C12.088 19 10.0942 17.0062 10.0942 14.5466C10.0942 12.0871 12.088 10.0933 14.5475 10.0933ZM10.1122 11.7121C9.87194 12.0873 9.67799 12.4949 9.53839 12.9269L3.82183 12.9272C3.48644 12.9272 3.21455 13.1991 3.21455 13.5344V14.2691C3.21455 14.8 3.44612 15.3045 3.84868 15.6506C4.86736 16.5264 6.40256 16.9766 8.47475 16.9766C8.95963 16.9766 9.41517 16.952 9.84164 16.903C10.0432 17.308 10.2973 17.6834 10.5938 18.0207C9.94428 18.1347 9.23746 18.1912 8.47475 18.1912C6.13512 18.1912 4.32234 17.6595 3.05688 16.5715C2.38595 15.9947 2 15.1539 2 14.2691V13.5344C2 12.5283 2.81566 11.7126 3.82183 11.7126L10.1122 11.7121ZM17.227 12.7266L12.7275 17.2261C13.2462 17.5791 13.8728 17.7854 14.5475 17.7854C16.3363 17.7854 17.7863 16.3354 17.7863 14.5466C17.7863 13.8719 17.58 13.2454 17.227 12.7266ZM14.5475 11.3078C12.7588 11.3078 11.3087 12.7579 11.3087 14.5466C11.3087 15.2214 11.515 15.8479 11.868 16.3666L16.3675 11.8672C15.8488 11.5142 15.2223 11.3078 14.5475 11.3078ZM8.47475 2C10.7107 2 12.5233 3.81258 12.5233 6.04851C12.5233 8.28444 10.7107 10.097 8.47475 10.097C6.23882 10.097 4.42624 8.28444 4.42624 6.04851C4.42624 3.81258 6.23882 2 8.47475 2ZM8.47475 3.21455C6.9096 3.21455 5.64079 4.48336 5.64079 6.04851C5.64079 7.61366 6.9096 8.88247 8.47475 8.88247C10.0399 8.88247 11.3087 7.61366 11.3087 6.04851C11.3087 4.48336 10.0399 3.21455 8.47475 3.21455Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-user-block-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-user-block", "wpp-icon-user-block-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-user-block-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-user-block-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconUserBlock$1);
      }
      break;
  } });
}

const WppIconUserBlock = WppIconUserBlock$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconUserBlock, defineCustomElement };
